import Action from '../Action'
import './styles/ModalMasiveDelete.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../LoadSimple';
import { useFetch } from '../../hooks/useFetch';
import { capitalizeFirstLetter } from '../../utils/utils';
import { lang } from '../generales/traduction';
const ModalMasiveDelete =({handleShowPopup,closeModalMasiveDelete,setSearchTerm,languaje,mode,user,dataUsers,devices,server,setRegisterIsValid,groupSelected,setData,loading,setLoading,setError,setEditActive,editActive,closCreateCisModal})=>{
    
    const [loadingM,setLoadingM]=useState(false);

    const [disabled,setDisabled]=useState(true)

    const [ManttoData,setManttoData]=useState({name_brand:(editActive)?groupSelected.name_brand:"",mac_address_brand_OUI:(editActive)?groupSelected.mac_address_brand_OUI:""})

   
    const [min,setMin]=useState(0)   
    const handleChange = (e) => {
      const value = e.target.value;
      if (!/^\d*$/.test(value)) return; // solo números enteros

      // Lógica adicional si lo necesitas:
      setMin(value)
    };
      const handleKeyDown = (e) => {
        const allowedKeys = [
          'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete',
        ];
        const isNumber = /^[0-9]$/;
      
        if (
          !allowedKeys.includes(e.key) &&
          !isNumber.test(e.key)
        ) {
          e.preventDefault();
        }
      };
      useEffect(()=>{
       
          search_massive_options() 
      },[])

      
      const Registrar=()=>{
        let  body ={
            option_ids: optionList,
            ack: textAck
        }



        setLoadingM(true)
        const fetchDataPost = async () => {
          
       try {
         // console.log(localStorage.getItem('access_token'))
         const response = await fetch(server.url+'/api/v1/cassia/events/massive/close', {
           method: 'POST',  
           headers: {
              "Accept": "application/json",
             'Content-Type': 'application/json',
               Authorization: `Bearer ${localStorage.getItem('access_token')}`,
             },
           body: JSON.stringify(body),
         });
         if (response.ok) {
           const data1 = await response.json();
           setLoadingM(false)

           handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),data1.message,data1.data.result_option_1, true)
           // console.log(data1);
           closeModalMasiveDelete()
         } else {
           const data1 = await response.json();
           handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
           throw new Error('Error en la solicitud');
         }
       } catch (error) {
              
          }
        };

        fetchDataPost();
      }
     const [closeOptionList, setCloseOptionList]=useState({data:[], loading:false ,error:''})
     const search_massive_options=()=>{
       
       
        setCloseOptionList({data:closeOptionList.data, loading:true ,error:''})
          const fetchDataPost = async () => {
           
         try {
           const response = await fetch(server.url+'/api/v1/cassia/events/massive/options', {
             method: 'GET',  
             headers: {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${localStorage.getItem('access_token')}`,
             },
           });
           if (response.ok) {
             const data1 = await response.json();
             setLoadingM(false)

             setCloseOptionList({data:data1.data, loading:false ,error:''})
           } else {
             const data1 = await response.json();
             throw new Error('Error en la solicitud');
           }
         } catch (error) {
              
              console.error(error);
            }
          };
      
          fetchDataPost();
          
    }
  const [closeOption,setCloseOption]=useState(0)
  const onChangeOption=(option)=>{
    setCloseOption(option)
  }
  const [closeMode,setCloseMode]=useState(1)
  const onChangeMode=(mode)=>{
    setCloseMode(mode)
    if(mode==2){
        setOptionlist([])
    }else if(mode==1){
        setOptionlist([1,2,3])
      
    }
  }
  const [textAck,setTextAck]=useState("")
    const handleTextAreaChange = (event) => {
      setTextAck(event.target.value);
        
      };

  const [optionList, setOptionlist] = useState([1,2,3]); // Estado para almacenar la lista de opciones seleccionadas  
  const toggleNumber = (num) => {
    setOptionlist((prev) => {
      if (prev.includes(num)) {
        // Si ya existe, lo eliminamos
        return prev.filter((n) => n !== num);
      } else {
        // Si no existe, lo agregamos
        return [...prev, num];
      }
    }); 
    };
    const {name_brand,mac_address_brand_OUI}=ManttoData;
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                <div className='txt-message-modal-delete-gs'>
                                               {capitalizeFirstLetter(lang[languaje]['cierreMasivo'])}
                                            </div>
                </div>
                <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                
                                    <div className="main-close-masive" > 
                                    
                                    <div className="mode-close-masive"  >
                                          <div className='title-text-close-masive' >
                                            {capitalizeFirstLetter(lang[languaje]['modoDeCierre'])}:
                                          </div>
                                          <div className='mode-option-close-masive' >
                                              <input type="radio" checked={closeMode==1} onChange={()=>{ onChangeMode(1)}} />
                                              &nbsp; 
                                              <div className='txt-option-close-masive' >
                                                  {capitalizeFirstLetter(lang[languaje]['cerrarTodosLosEventos'])} (default)
                                                  </div>
                                          </div>
                                          <div className='mode-option-close-masive' >
                                              <input type="radio" checked={closeMode==2} onChange={()=>{ onChangeMode(2)}} />
                                              &nbsp; 
                                              <div className='txt-option-close-masive' >
                                                 {capitalizeFirstLetter(lang[languaje]['cierrePersonalizado'])}
                                                  </div>
                                          </div>
                                    </div>
                                    <div className='body-close-masive' >
                                      <div className='top-body-close-masive' >
                                        {
                                          closeOptionList.loading?
                                          <LoadSimple></LoadSimple>:
                                        closeOptionList.data.map((option,index)=>
                                            <div className="content-close-masive-options" id={option.id} >
                                              <div className={'compact-close-masive-options '+((optionList.includes(option.id) || closeMode==1)?'close-masive-selected':'')} onClick={()=>{ toggleNumber(option.id)}}>
                                                  <div className='title-option-close-masive '>
                                                      {capitalizeFirstLetter(lang[languaje][option.name])} 
                                                  </div>
                                                  <div className='body-option-close-masive '>
                                                      {capitalizeFirstLetter(lang[languaje][option.description])} .  
                                                  </div>
                                              </div>
                                            </div>
                                      )}
                                      
                                      </div>
                                      <div className='bottom-body-close-masive' >
                                          <textarea  className='text-close-masive' maxlength="5000" id="nota" name="nota" onChange={handleTextAreaChange}></textarea>
                                        <label className='lbl-text-close-masive'>{capitalizeFirstLetter(lang[languaje]['mensajeDeCierre'])}</label> 
                                          {/* <textarea className='' placeholder='Descripción del cierre (opcional)' ></textarea>   */}
                                      </div>
                                      
                                   
                                    
                                    </div>
                                    
                                    <div className="buttons-close-masive" >
                                        {
                                            (loadingM)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closeModalMasiveDelete}/>
                                            <Action disabled={(optionList.length==0 || textAck=="")?true:false} origen='Red' titulo={capitalizeFirstLetter(lang[languaje]['eliminar'])}  action={Registrar}/>
                                            </>
                                        }
                                    </div>
                                </div>
                </div>
                </div>
        </div>
    )
}

export default ModalMasiveDelete